export const FREQUENCIES = [
    { value: 'NOT_REPEAT', label: 'schedule.frequencies.not.repeat' },
    { value: 'DAILY', label: 'schedule.frequencies.daily' },
    { value: 'EVERY_OTHER_DAY', label: 'schedule.frequencies.every.other.day' },
    { value: 'WEEKLY', label: 'schedule.frequencies.weekly' },
    { value: 'MONTHLY', label: 'schedule.frequencies.monthly' },
    { value: 'YEARLY', label: 'schedule.frequencies.yearly' },
]

export const WEEKLY_DAYS = [
    { value: 0, label: 'schedule.weekly.days.sunday' },
    { value: 1, label: 'schedule.weekly.days.monday' },
    { value: 2, label: 'schedule.weekly.days.tuesday' },
    { value: 3, label: 'schedule.weekly.days.wednesday' },
    { value: 4, label: 'schedule.weekly.days.thursday' },
    { value: 5, label: 'schedule.weekly.days.friday' },
    { value: 6, label: 'schedule.weekly.days.saturday' },
]

export const MONTHS = [
    { value: 0, label: 'schedule.months.january' },
    { value: 1, label: 'schedule.months.february' },
    { value: 2, label: 'schedule.months.march' },
    { value: 3, label: 'schedule.months.april' },
    { value: 4, label: 'schedule.months.may' },
    { value: 5, label: 'schedule.months.june' },
    { value: 6, label: 'schedule.months.july' },
    { value: 7, label: 'schedule.months.august' },
    { value: 8, label: 'schedule.months.september' },
    { value: 9, label: 'schedule.months.october' },
    { value: 10, label: 'schedule.months.november' },
    { value: 11, label: 'schedule.months.december' },
]
